import React from 'react';
import Icon from '../../../../common/components/icons/Icon';
import { primitiveColors, spacing } from '../../../../theming';
import styles from './Stepper.module.scss';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../../hooks/useMediaQuery';

const Stepper = () => {
    const { t } = useTranslation(['payment']);

    const { isExtraSmallDevice } = useMedia();

    return (
        <div className={styles.stepper} style={{ gap: isExtraSmallDevice ? spacing[1] : spacing[3] }}>
            <div className={`${styles.step} ${styles.completed}`}>
                <Icon color={primitiveColors.text} name="PreCheck" size={24} />
                <span style={{ fontWeight: '700' }} className={styles.label}>
                    {t('stepper.precheck')}
                </span>
            </div>
            <div
                className={styles.line}
                style={{ width: isExtraSmallDevice ? '20px' : '40px', flexGrow: isExtraSmallDevice ? 0 : 1 }}
            ></div>
            <div className={`${styles.step} ${styles.active}`}>
                <div className={styles.circle}>2</div>
                <span className={styles.label}>{t('stepper.plan')}</span>
            </div>
            <div
                className={styles.lineDisabled}
                style={{
                    width: isExtraSmallDevice ? '20px' : '40px',
                    flexGrow: isExtraSmallDevice ? 0 : 1,
                }}
            ></div>
            <div className={`${styles.step} ${styles.disabled}`}>
                <div className={styles.circle}>3</div>
                <span className={styles.label}>{t('stepper.payment')}</span>
            </div>
        </div>
    );
};

export default Stepper;
